// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgGoogleUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.04772 16.4308L6.48926 13.8588C6.29246 13.2747 6.18605 12.6498 6.18605 11.9998C6.18605 11.3498 6.29246 10.7249 6.48924 10.1408L3.0477 7.56885C2.37646 8.9025 2 10.4061 2 11.9998C2 13.5935 2.37647 15.0971 3.04772 16.4308Z"
					fill="#FBBC05"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.48915 10.141C7.2832 7.78406 9.54873 6.09091 12.2325 6.09091C13.6743 6.09091 14.9767 6.59091 15.9999 7.40909L18.9767 4.5C17.1627 2.95455 14.8371 2 12.2325 2C8.18881 2 4.71201 4.26209 3.04761 7.56906L6.48915 10.141Z"
					fill="#EA4335"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.04639 16.4281C4.71025 19.7365 8.18785 21.9998 12.2326 21.9998C17.3489 21.9998 22.0001 18.3635 22.0001 11.9998C22.0001 11.4089 21.907 10.7726 21.7675 10.1816H12.2326V14.0453H17.721C17.2094 16.4998 15.0698 17.9089 12.2326 17.9089C9.54575 17.9089 7.27806 16.2118 6.48652 13.8506L3.04639 16.4281Z"
					fill="#34A853"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.2327 10.1816H21.7676C21.9071 10.7725 22.0001 11.4089 22.0001 11.9998C22.0001 15.2592 20.78 17.8031 18.9021 19.5094L15.6349 17.0374C16.7032 16.3785 17.4465 15.3624 17.721 14.0453H12.2327V10.1816Z"
					fill="#4285F4"
				/>
			</Svg>
		);
	}
);
SvgGoogleUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgGoogleUnique24;
